import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import Datetime from 'react-datetime';
import { date_format } from '../../../server/constants';
import moment from 'moment';
import { _addNotification, _addNotificationError, getSchoolGrades, groupBy } from '../../../server/util';
import { postWithHeaders } from '../../../server/actions';

let schoolId = 0;
let loggedUser = '';
let userName = "";
const formGroupMargin = {
    marginBottom: '5px'
};

class AutomateSchoolYear extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            schoolYearRec: { sisLoad: false },
            existingSchoolYearList: [],
            schoolYearsId: 0,
        }

    }

    componentWillMount = () => {
        const { yid, data } = this.props.location.state;
        //let yid=queryString.parse(window.location.search);
        const loggedUser = sessionStorage.getItem('loggedInUserInfo') || '';
        if (sessionStorage.getItem('ROLE') === 'ROLE_SUPERADMIN') {
            schoolId = this.props.school._links.self.href.split('/').pop();
        }
        else {
            schoolId = sessionStorage.getItem('SchoolId');
        }
        this.setState({ schoolYearsId: yid || 0, existingSchoolYearList: data })
    }
    componentDidMount() {
        const { existingSchoolYearList, schoolYearRec } = this.state
        this._notificationSystem = this.refs.notificationSystem;
        const sortedSchoolYears = (Object.values(existingSchoolYearList) || []).sort((a, b) => Number(a.schoolYears) - Number(b.schoolYears));
        const latestRec = sortedSchoolYears.length > 0 ? sortedSchoolYears[sortedSchoolYears.length - 1] : {};
        schoolYearRec.sessionStartDateTime = moment(latestRec.sessionEndDateTime).isValid() ? moment(latestRec.sessionEndDateTime).add('d', 1) : moment();
        schoolYearRec.schoolActualStartDate = moment(latestRec.sessionEndDateTime).isValid() ? moment(latestRec.sessionEndDateTime).add('d', 1) : moment();
        schoolYearRec.sessionEndDateTime = moment(latestRec.sessionEndDateTime).isValid() ? moment(latestRec.sessionEndDateTime).add('y', 1) : moment();
        this.setState({ schoolYearRec: { ...schoolYearRec } });
    }
    validStartDate = (currentDate) => {
        const { existingSchoolYearList } = this.state;
        const sortedSchoolYears = (Object.values(existingSchoolYearList) || []).sort((a, b) => Number(a.schoolYears) - Number(b.schoolYears));
        let latestRec = sortedSchoolYears.length > 0 ? sortedSchoolYears[sortedSchoolYears.length - 1] : undefined;
        if (!latestRec) {
            latestRec = {};
            latestRec.sessionStartDateTime = moment();
            latestRec.sessionEndDateTime = moment();
        }

        return currentDate > (moment(latestRec.sessionEndDateTime, 'YYYY-MM-DDThh:mm:ss').isValid() ? moment(latestRec.sessionEndDateTime, 'YYYY-MM-DDThh:mm:ss') : moment());
    }
    validEndDate = (currentDate) => {
        const { schoolYearRec } = this.state;
        return currentDate > moment(schoolYearRec.sessionStartDateTime, 'YYYY-MM-DDThh:mm:ss');
    }
    validActiveStartDate = (currentDate) => {
        const { schoolYearRec } = this.state;
        return currentDate >= moment(schoolYearRec.sessionStartDateTime, 'YYYY-MM-DDThh:mm:ss') && currentDate <= moment(schoolYearRec.sessionEndDateTime, 'YYYY-MM-DDThh:mm:ss');

    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar} >
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    validateSchoolYearDates = () => {
        const { existingSchoolYearList, schoolYearRec, schoolYearsId } = this.state;
        return existingSchoolYearList.filter(r => r.schoolYears != schoolYearsId).some(rec => {
            const sdate = moment.utc(rec.sessionStartDateTime).local();
            const edate = moment.utc(rec.sessionEndDateTime).local();
            const cSDate = schoolYearRec.sessionStartDateTime;
            const cEDate = schoolYearRec.sessionEndDateTime
            return (cSDate <= edate || cEDate < edate)
        })
    }
    onClickSave = (e) => {
        e.preventDefault();
        if (this.validateSchoolYearDates()) {
            _addNotificationError('school year start and end dates overlapped with existing school years.', this);
            return false;
        }
        this.setState({ loading: true, step1Loading: true });
        let headers = {
            'Content-Type': 'application/json'
        };
        let _schoolYearRec = Object.assign({}, this.state.schoolYearRec);
        let sd = moment(_schoolYearRec.sessionStartDateTime).startOf('day');
        let ed = moment(_schoolYearRec.sessionEndDateTime).endOf('day')
        _schoolYearRec.loggedUser = JSON.parse(sessionStorage.getItem('loggedInUserInfo')).username;
        _schoolYearRec.schoolYear = moment(_schoolYearRec.sessionStartDateTime).format('YYYY')
        _schoolYearRec.name = moment(_schoolYearRec.sessionStartDateTime).format('YYYY') + '-' + moment(_schoolYearRec.sessionEndDateTime).format('YYYY');
        _schoolYearRec.sessionStartDateTime = moment(sd).utc().format("YYYY-MM-DDTHH:mm:ss");
        _schoolYearRec.sessionEndDateTime = moment(ed).utc().format("YYYY-MM-DDTHH:mm:ss");
        _schoolYearRec.schoolActualStartDate = moment(_schoolYearRec.schoolActualStartDate).startOf('day').utc().format("YYYY-MM-DDTHH:mm:ss");
        postWithHeaders('/schoolYearSetup/' + this.state.schoolYearsId + '?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&access_token=', JSON.stringify(_schoolYearRec), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            if (data.statusCode == 200) {
                _addNotification("New school year created successfully", this);
                this.setState({ loading: false });
                this.context.router.history.push('/schoolAdmin/manageSchools');
            } else {
                throw Error(data.statusText);
            }
        }).catch(
            (error) => {
                console.log('School Year data not saved', error);
                _addNotificationError(error.message, this);
                this.setState({ loading: false });
            }
        );
    }
    render() {
        const { loading, schoolYearRec } = this.state;
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={loading}
                    />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                            <h2>
                                <span>New School Year Migration</span>
                            </h2>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="panel panel-primary">
                                <div className="panel-body">
                                    <Fragment>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group" style={formGroupMargin}>
                                                    <label className="custom-label col-md-6 text-left" style={{ margin: '10px 0px' }}>Start Date</label>
                                                    <div className="input-group col-md-6 col-sm-12 col-xs-12">
                                                        <Datetime ref='calendar' dateFormat={date_format()} timeFormat={false}
                                                            closeOnSelect={true} value={moment(schoolYearRec.sessionStartDateTime).toDate()}
                                                            isValidDate={this.validStartDate}
                                                            onChange={(e) => {
                                                                let _schoolYear = schoolYearRec
                                                                let _sDate = moment(e)
                                                                _schoolYear.sessionStartDateTime = moment(_sDate).format("YYYY-MM-DDTHH:mm:ss");
                                                                this.setState({ schoolYearRec: _schoolYear })
                                                            }} renderInput={this.renderInput} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group" style={formGroupMargin}>
                                                    <label className="custom-label col-md-6 text-left" style={{ margin: '10px 0px' }}>End Date</label>
                                                    <div className="input-group col-md-6 col-sm-12 col-xs-12">
                                                        <Datetime ref='calendar' dateFormat={date_format()} timeFormat={false}
                                                            closeOnSelect={true} value={moment(schoolYearRec.sessionEndDateTime).toDate()}
                                                            isValidDate={this.validEndDate}
                                                            onChange={(e) => {
                                                                let _schoolYear = schoolYearRec
                                                                let _sDate = moment(e)
                                                                _schoolYear.sessionEndDateTime = moment(_sDate).format("YYYY-MM-DDTHH:mm:ss");
                                                                this.setState({ schoolYearRec: _schoolYear })
                                                            }} renderInput={this.renderInput} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group" style={formGroupMargin}>
                                                    <label className="custom-label col-md-6 text-left" style={{ margin: '10px 0px' }}>Actual Start Date</label>
                                                    <div className="input-group col-md-6 col-sm-12 col-xs-12">
                                                        <Datetime ref='calendar' dateFormat={date_format()} timeFormat={false}
                                                            closeOnSelect={true} value={moment(schoolYearRec.schoolActualStartDate)}
                                                            isValidDate={this.validActiveStartDate}
                                                            onChange={(e) => {
                                                                let _schoolYear = schoolYearRec
                                                                let _sDate = moment(e)
                                                                _schoolYear.schoolActualStartDate = moment(_sDate).format("YYYY-MM-DDTHH:mm:ss");
                                                                this.setState({ schoolYearRec: _schoolYear })
                                                            }} renderInput={this.renderInput} />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className="checkbox" style={{ marginLeft: '30px' }}>
                                                    <label>
                                                        <input name="sisLoad" id="sisLoad" className='chbox' checked={schoolYearRec.sisLoad} type="checkbox" onChange={(e) => {
                                                            let _schoolYear = schoolYearRec;
                                                            _schoolYear.sisLoad = e.target.checked;
                                                            this.setState({ schoolYearRec: _schoolYear });

                                                        }} /> Import students using SIS load
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-12 text-center'>
                                                <p style={{ fontSize: '12px', marginLeft: '30px' }}>
                                                    <b>Note: </b>
                                                    <span>
                                                        Previous school year all settings will be copied to new school year, you can modify them anytime by updating school year.
                                                    </span>
                                                </p>
                                            </div>

                                            <div className='col-md-12 text-right'>
                                                <button type='button' className='btn btn-sm btn-primary' onClick={(e) => {
                                                    this.context.router.history.push('/schoolAdmin/manageSchools');
                                                }} >Cancel</button>
                                                {'   '}
                                                <button type="button" className={'btn btn-sm btn-primary'}
                                                    onClick={(e) => this.onClickSave(e, 1)}>
                                                    {loading == true ? <Fragment><i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading</Fragment> : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </Fragment>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
AutomateSchoolYear.contextTypes = {
    router: PropTypes.object.isRequired
};

export default AutomateSchoolYear;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/ManageSchools/automateSchoolYear.js